import { motion } from "framer-motion";
import { styled as stmu } from "@material-ui/core/styles"
import styled, { css } from "styled-components";
import { theme } from '../../theme'

export const Label = stmu('label')(({ theme }) => ({
    pointerEvents: 'none',
    color: theme.colors.black,
    whiteSpace: 'nowrap',
    marginBottom: '1.5rem',
    fontSize: '1.2rem',
    display: 'block',
    fontWeight: 700,
    textTransform: 'uppercase'
}));

export const InputWrapperDiv = stmu('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
}));

export const InputField = stmu('input')(({ theme }) => ({
    width: '100%',
    // border: 'none',
    outline: 'none',
    fontSize: '1.5rem',
    appearance: 'none',
    borderRadius: 0,
    padding: '0 1.2rem',
    boxSizing: 'border-box',
    height: '50px',
    border: '1px solid rgb(243 242 242)',
    backgroundColor: theme.colors.white,
    borderRadius: '4px',

    "&::placeholder": {
        fontSize: "1.2rem",
        color: "#969696",
        fontFamily: "Quicksand, san-serif",
    },

    "&.search": {
        width: '27.1rem',
        height: '3.2rem',
        borderRadius: '4px',
        paddingLeft: '36px',
        backgroundColor: theme.colors.white,
    }
}));

export const InputWrapper = styled.div`
   margin: 2rem 0;
   width: 100%;

   &.grid-2-2 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;

      @media only screen and (max-width: 468px) {
         display: grid;
         grid-template-columns: repeat(1, 1fr);
         row-gap: 20px;
         width: 100%;
      }
   }
`;

// export const AdornmentWrapperDiv = stmu('div')(({ theme }) => ({
//     display: 'flex',
//     alignItems: 'center',
//     whiteSpace: 'nowrap',
//     position: 'absolute',


//     "&.search": {

//         color: theme.colors.navLinkColorDefault,

//         "&svg": {
//             width: '24px',
//             height: '24px',
//         }
//     },
//     "&.end": {
//         right: '0',
//     }
// }));

export const AdornmentWrapperDiv = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    position: absolute;


    &.search{

        color: ${theme.colors.navLinkColorDefault};
        left: 0.8rem;
        svg {
            width: 1.8rem;
            height: 1.8rem;
        }
    }
    &.end {
        right: 0;
    }

`



export const ErrorText = styled(motion.p)`
   margin: 0.1rem 0 0 0;
   color: ${theme.colors.redError};
   font-size: 1.4rem;
   letter-spacing: -0.01rem;
   font-weight: 700;

   ${({ easyFlow }) =>
        easyFlow &&
        css`
         margin: 0;
         position: absolute;
         left: 65px;
         bottom: -21px;
         font-size: 11.5px;
      `}
`;